import { useState } from "react";
import {
  Card,
  CardHeader,
  CardHeaderBtn,
  CardBody,
} from "./../../components/card/card.jsx";

function FormWizards() {
  const [step, setStep] = useState(1);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPlan5, setSelectedPlan5] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedVehicle, setSelectedVehicle] = useState({
    brand: "",
    model: "",
  });
  const [financingMonths, setFinancingMonths] = useState(12);
  const [downPaymentPercentage, setDownPaymentPercentage] = useState(10);

  const handleNextStep = () => setStep(step + 1);
  const handlePreviousStep = () => setStep(step - 1);

  const calculateMonthlyPayment = () => {
    if (selectedVehicle.brand && selectedVehicle.model) {
      const vehiclePrice =
        vehicleData[selectedVehicle.brand][selectedVehicle.model];
      const downPayment = (downPaymentPercentage / 100) * vehiclePrice;
      const financedAmount = vehiclePrice - downPayment;
      const monthlyPayment = financedAmount / financingMonths;
      return monthlyPayment.toFixed(2);
    }
    return 0;
  };

  const plans = [
    {
      title: "Cobertura de Llantas Plan 12000",
      status: "Nuevo",
      price: "$6,896.00",
    },
    {
      title: "Cobertura de Llantas Plan 12000",
      status: "Nuevo",
      price: "$7,200.00",
    },
    {
      title: "Cobertura de Llantas Plan 12000",
      status: "Nuevo",
      price: "$8,000.00",
    },
  ];

  const plans5 = [
    {
      title: "Cobertura de Llantas Plan 5000",
      status: "Nuevo",
      price: "$5,000.00",
    },
    {
      title: "Cobertura de Llantas Plan 5000",
      status: "Nuevo",
      price: "$5,500.00",
    },
    {
      title: "Cobertura de Llantas Plan 5000",
      status: "Nuevo",
      price: "$6,000.00",
    },
  ];

  const vehicleData = {
    Toyota: {
      Corolla: 250000,
      Camry: 350000,
    },
    Honda: {
      Civic: 270000,
      Accord: 370000,
    },
    Ford: {
      Focus: 230000,
      Fusion: 330000,
    },
  };

  const [formData, setFormData] = useState({
    nombre: "",
    apellido: "",
    telefono: "",
    correo_electronico: "",
    acepta_aviso_privacidad: false,
    depende_auto: "",
    condiciones_calle: "",
    perdio_llaves: "",
    tipo_auto: "",
    preocupacion_fallas: "",
    preocupacion_robo: "",
    ingreso_mensual: "",
    edad: "",
    enganche: "",
    historial_crediticio: "",
    tipo_trabajo: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleSubmit = async () => {
    if (
      formData.nombre &&
      formData.apellido &&
      formData.correo_electronico &&
      selectedVehicle.brand &&
      selectedVehicle.model
    ) {
      setIsSubmitting(true); // Bloquea temporalmente el botón
      const dataToSend = {
        ...formData,
        access_token: "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3",
        marca_vehiculo: selectedVehicle.brand,
        modelo_vehiculo: selectedVehicle.model,
        meses_financiamiento: financingMonths,
        porcentaje_enganche: downPaymentPercentage,
        mensualidad_estimacion: calculateMonthlyPayment(),
        accesorios_seleccionados:
          selectedPlan !== null ? plans[selectedPlan] : null,
        planes_seleccionados:
          selectedPlan !== null ? plans5[selectedPlan] : null,
      };

      try {
        const response = await fetch(
          "https://api.checkmark.mx/ventas/financiamiento",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToSend),
          }
        );

        const result = await response.json();

        if (result.statusCode === 200) {
          alert("Venta registrada exitosamente");
          setIsSubmitted(true); // Bloquea todo el formulario
        } else {
          alert(
            result.message || "Por favor, complete todos los campos requeridos."
          );
        }
      } catch (error) {
        console.error("Error al enviar la solicitud:", error);
        alert("Hubo un error al enviar los datos");
      } finally {
        setIsSubmitting(false); // Detiene el estado de envío
      }
    } else {
      alert("Por favor, complete todos los campos requeridos.");
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <div id="wizardLayout1" className="mb-5">
                <h4>COMPRA TU AUTO</h4>
                <Card>
                  <CardHeader className="with-btn">
                    FINANCIAMIENTO
                    <CardHeaderBtn />
                  </CardHeader>
                  <CardBody>
                    <div className="nav-wizards-container">
                      <nav className="nav nav-wizards-3 mb-2">
                        <div className="nav-item col">
                          <a
                            className={`nav-link ${
                              step >= 1 ? "completed" : ""
                            } ${step === 1 ? "active" : ""}`}
                            href="#/"
                          >
                            <div className="nav-dot"></div>
                            <div className="nav-title">1</div>
                            <div className="nav-text">Información personal</div>
                          </a>
                        </div>

                        <div className="nav-item col">
                          <a
                            className={`nav-link ${
                              step >= 2 ? "completed" : ""
                            } ${step === 2 ? "active" : ""}`}
                            href="#/"
                          >
                            <div className="nav-dot"></div>
                            <div className="nav-title">2</div>
                            <div className="nav-text">Entrevista</div>
                          </a>
                        </div>

                        <div className="nav-item col">
                          <a
                            className={`nav-link ${
                              step >= 3 ? "completed" : ""
                            } ${step === 3 ? "active" : ""}`}
                            href="#/"
                          >
                            <div className="nav-dot"></div>
                            <div className="nav-title">3</div>
                            <div className="nav-text">Postula</div>
                          </a>
                        </div>

                        <div className="nav-item col">
                          <a
                            className={`nav-link ${
                              step >= 4 ? "completed" : ""
                            } ${step === 4 ? "active" : ""}`}
                            href="#/"
                          >
                            <div className="nav-dot"></div>
                            <div className="nav-title">4</div>
                            <div className="nav-text">Accesorios</div>
                          </a>
                        </div>

                        <div className="nav-item col">
                          <a
                            className={`nav-link ${
                              step >= 5 ? "completed" : ""
                            } ${step === 5 ? "active" : ""}`}
                            href="#/"
                          >
                            <div className="nav-dot"></div>
                            <div className="nav-title">5</div>
                            <div className="nav-text">Planes</div>
                          </a>
                        </div>

                        <div className="nav-item col">
                          <a
                            className={`nav-link ${
                              step >= 6 ? "completed" : ""
                            } ${step === 6 ? "active" : ""}`}
                            href="#/"
                          >
                            <div className="nav-dot"></div>
                            <div className="nav-title">6</div>
                            <div className="nav-text">Financiamiento</div>
                          </a>
                        </div>
                      </nav>
                    </div>

                    <Card>
                      <CardBody>
                        {step === 1 && (
                          <div>
                            <h5>Información personal</h5>
                            {/* Primera fila: Nombre y Apellido */}
                            <div className="row mb-3">
                              <div className="col-lg-6">
                                <label>Nombre</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Nombre"
                                  name="nombre"
                                  value={formData.nombre}
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col-lg-6">
                                <label>Apellido</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Apellido"
                                  name="apellido"
                                  value={formData.apellido}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>

                            {/* Segunda fila: Número de Teléfono y Correo Electrónico */}
                            <div className="row mb-3">
                              <div className="col-lg-6">
                                <label>Número de teléfono</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Teléfono"
                                  name="telefono"
                                  value={formData.telefono}
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col-lg-6">
                                <label>Correo electrónico</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Correo"
                                  name="correo_electronico"
                                  value={formData.correo_electronico}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>

                            {/* Fila para el checkbox */}
                            <div className="form-check mb-3">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="privacyCheck"
                                name="acepta_aviso_privacidad"
                                checked={formData.acepta_aviso_privacidad}
                                onChange={handleCheckboxChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="privacyCheck"
                              >
                                Acepto el aviso de privacidad
                              </label>
                            </div>
                          </div>
                        )}
                        {step === 2 && (
                          <div>
                            <h5>Entrevista</h5>

                            <div className="row mb-3">
                              {/* Pregunta 1: ¿Qué tanto depende de su automóvil? */}
                              <div className="col-md-6">
                                <label>
                                  ¿Qué tanto depende de su automóvil?
                                </label>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="depende_auto"
                                    id="dependeMucho"
                                    value="En gran medida"
                                    checked={
                                      formData.depende_auto === "En gran medida"
                                    }
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="dependeMucho"
                                  >
                                    En gran medida
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="depende_auto"
                                    id="dependePoco"
                                    value="Poco"
                                    checked={formData.depende_auto === "Poco"}
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="dependePoco"
                                  >
                                    Poco
                                  </label>
                                </div>
                              </div>

                              {/* Pregunta 2: ¿Cuáles son las condiciones de la calle donde transita? */}
                              <div className="col-md-6">
                                <label>
                                  ¿Cuáles son las condiciones de la calle donde
                                  transita?
                                </label>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="condiciones_calle"
                                    id="condicionBuena"
                                    value="Buena"
                                    checked={
                                      formData.condiciones_calle === "Buena"
                                    }
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="condicionBuena"
                                  >
                                    Buena
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="condiciones_calle"
                                    id="condicionMedia"
                                    value="Media"
                                    checked={
                                      formData.condiciones_calle === "Media"
                                    }
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="condicionMedia"
                                  >
                                    Media
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="condiciones_calle"
                                    id="condicionMala"
                                    value="Mala"
                                    checked={
                                      formData.condiciones_calle === "Mala"
                                    }
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="condicionMala"
                                  >
                                    Mala
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="row mb-3">
                              {/* Pregunta 3: ¿Ha perdido sus llaves del auto? */}
                              <div className="col-md-6">
                                <label>¿Ha perdido sus llaves del auto?</label>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="perdio_llaves"
                                    id="perdidoSi"
                                    value="Si"
                                    checked={formData.perdio_llaves === "Si"}
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="perdidoSi"
                                  >
                                    Si
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="perdio_llaves"
                                    id="perdidoNo"
                                    value="No"
                                    checked={formData.perdio_llaves === "No"}
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="perdidoNo"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>

                              {/* Pregunta 4: ¿Qué tipo de auto busca? */}
                              <div className="col-md-6">
                                <label>¿Qué tipo de auto busca?</label>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="tipo_auto"
                                    id="tipoNuevo"
                                    value="Nuevo"
                                    checked={formData.tipo_auto === "Nuevo"}
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="tipoNuevo"
                                  >
                                    Nuevo
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="tipo_auto"
                                    id="tipoSeminuevo"
                                    value="Seminuevo"
                                    checked={formData.tipo_auto === "Seminuevo"}
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="tipoSeminuevo"
                                  >
                                    Seminuevo
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="row mb-3">
                              {/* Pregunta 5: ¿Cuánto le preocupa la posibilidad de fallos o averías inesperadas? */}
                              <div className="col-md-6">
                                <label>
                                  ¿Cuánto le preocupa la posibilidad de fallos o
                                  averías inesperadas?
                                </label>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="preocupacion_fallas"
                                    id="preocupacionMucho"
                                    value="Mucho"
                                    checked={
                                      formData.preocupacion_fallas === "Mucho"
                                    }
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="preocupacionMucho"
                                  >
                                    Mucho
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="preocupacion_fallas"
                                    id="preocupacionPoco"
                                    value="Poco"
                                    checked={
                                      formData.preocupacion_fallas === "Poco"
                                    }
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="preocupacionPoco"
                                  >
                                    Poco
                                  </label>
                                </div>
                              </div>

                              {/* Pregunta 6: ¿Le preocupa que su vehículo sea robado o se pierda? */}
                              <div className="col-md-6">
                                <label>
                                  ¿Le preocupa que su vehículo sea robado o se
                                  pierda?
                                </label>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="preocupacion_robo"
                                    id="roboSi"
                                    value="Si"
                                    checked={
                                      formData.preocupacion_robo === "Si"
                                    }
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="roboSi"
                                  >
                                    Si
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="preocupacion_robo"
                                    id="roboNo"
                                    value="No"
                                    checked={
                                      formData.preocupacion_robo === "No"
                                    }
                                    onChange={handleInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="roboNo"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {step === 3 && (
                          <div>
                            <h5>Postula</h5>
                            <div className="row">
                              {/* ¿Cuál es su ingreso mensual? */}
                              <div className="col-md-6 mb-3">
                                <div className="form-group">
                                  <label htmlFor="ingreso_mensual">
                                    ¿Cuál es su ingreso mensual?
                                  </label>
                                  <input
                                    type="number"
                                    id="ingreso_mensual"
                                    name="ingreso_mensual"
                                    className="form-control"
                                    placeholder="Ingrese su ingreso mensual"
                                    value={formData.ingreso_mensual || ""}
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </div>

                              {/* ¿Qué edad tiene? */}
                              <div className="col-md-6 mb-3">
                                <div className="form-group">
                                  <label htmlFor="edad">¿Qué edad tiene?</label>
                                  <input
                                    type="number"
                                    id="edad"
                                    name="edad"
                                    className="form-control"
                                    placeholder="Ingrese su edad"
                                    value={formData.edad || ""}
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              {/* ¿Cuánto busca dar de enganche? */}
                              <div className="col-md-6 mb-3">
                                <div className="form-group">
                                  <label htmlFor="enganche">
                                    ¿Cuánto busca dar de enganche?
                                  </label>
                                  <input
                                    type="number"
                                    id="enganche"
                                    name="enganche"
                                    className="form-control"
                                    placeholder="Ingrese el enganche"
                                    value={formData.enganche || ""}
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </div>

                              {/* ¿Tiene historial crediticio? */}
                              <div className="col-md-6 mb-3">
                                <div className="form-group">
                                  <label>¿Tiene historial crediticio?</label>
                                  <div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        name="historial_crediticio"
                                        id="historialSi"
                                        value="Si"
                                        checked={
                                          formData.historial_crediticio === "Si"
                                        }
                                        onChange={handleInputChange}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="historialSi"
                                      >
                                        Si
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        name="historial_crediticio"
                                        id="historialNo"
                                        value="No"
                                        checked={
                                          formData.historial_crediticio === "No"
                                        }
                                        onChange={handleInputChange}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="historialNo"
                                      >
                                        No
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              {/* ¿Independiente o asalariado? */}
                              <div className="col-md-6 mb-3">
                                <div className="form-group">
                                  <label>¿Independiente o asalariado?</label>
                                  <div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        name="tipo_trabajo"
                                        id="independiente"
                                        value="Independiente"
                                        checked={
                                          formData.tipo_trabajo ===
                                          "Independiente"
                                        }
                                        onChange={handleInputChange}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="independiente"
                                      >
                                        Independiente
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        name="tipo_trabajo"
                                        id="asalariado"
                                        value="Asalariado"
                                        checked={
                                          formData.tipo_trabajo === "Asalariado"
                                        }
                                        onChange={handleInputChange}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="asalariado"
                                      >
                                        Asalariado
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {step === 4 && (
                          <div>
                            <h5>Accesorios</h5>
                            <div className="row">
                              {plans.map((plan, index) => (
                                <div className="col-md-4 mb-4" key={index}>
                                  <div
                                    className={`card ${
                                      selectedPlan === index
                                        ? "border-primary"
                                        : ""
                                    }`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setSelectedPlan(index)}
                                  >
                                    <div className="card-body text-center">
                                      <h5 className="card-title">
                                        {plan.title}
                                      </h5>
                                      <p className="card-text">{plan.status}</p>
                                      <h6 className="card-price">
                                        {plan.price}
                                      </h6>
                                      <div className="">
                                        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary me-2">
                                          Oferta 1
                                        </span>
                                        <span className="badge bg-success bg-opacity-10 text-success border border-success me-2">
                                          Oferta 2
                                        </span>
                                        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary me-2">
                                          Oferta 3
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        {step === 5 && (
                          <div>
                            <h5>Planes</h5>
                            <div className="row">
                              {plans5.map((plan, index) => (
                                <div className="col-md-4 mb-4" key={index}>
                                  <div
                                    className={`card ${
                                      selectedPlan5 === index
                                        ? "border-primary"
                                        : ""
                                    }`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setSelectedPlan5(index)}
                                  >
                                    <div className="card-body text-center">
                                      <h5 className="card-title">
                                        {plan.title}
                                      </h5>
                                      <p className="card-text">{plan.status}</p>
                                      <h6 className="card-price">
                                        {plan.price}
                                      </h6>
                                      <div className="">
                                        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary me-2">
                                          Oferta 1
                                        </span>
                                        <span className="badge bg-success bg-opacity-10 text-success border border-success me-2">
                                          Oferta 2
                                        </span>
                                        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary me-2">
                                          Oferta 3
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        {step === 6 && (
                          <div id="wizardLayout1" className="mb-5">
                            <h4>Financiamiento</h4>
                            <Card>
                              <CardBody>
                                <div className="row">
                                  {/* Marca del Vehículo */}
                                  <div className="col-md-6 mb-3">
                                    <label>Marca del Vehículo:</label>
                                    <select
                                      className="form-control custom-select"
                                      onChange={(e) =>
                                        setSelectedVehicle({
                                          ...selectedVehicle,
                                          brand: e.target.value,
                                          model: "",
                                        })
                                      }
                                    >
                                      <option value="">
                                        Seleccione una marca
                                      </option>
                                      {Object.keys(vehicleData).map((brand) => (
                                        <option key={brand} value={brand}>
                                          {brand}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                  {/* Modelo del Vehículo */}
                                  {selectedVehicle.brand && (
                                    <div className="col-md-6 mb-3">
                                      <label>Modelo del Vehículo:</label>
                                      <select
                                        className="form-control custom-select"
                                        onChange={(e) =>
                                          setSelectedVehicle({
                                            ...selectedVehicle,
                                            model: e.target.value,
                                          })
                                        }
                                      >
                                        <option value="">
                                          Seleccione un modelo
                                        </option>
                                        {Object.keys(
                                          vehicleData[selectedVehicle.brand]
                                        ).map((model) => (
                                          <option key={model} value={model}>
                                            {model}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  )}
                                </div>

                                <div className="row">
                                  {/* Meses de Financiamiento */}
                                  <div className="col-md-6 mb-3">
                                    <label>Meses de Financiamiento:</label>
                                    <select
                                      className="form-control custom-select"
                                      value={financingMonths}
                                      onChange={(e) =>
                                        setFinancingMonths(
                                          Number(e.target.value)
                                        )
                                      }
                                    >
                                      <option value={12}>12 meses</option>
                                      <option value={24}>24 meses</option>
                                      <option value={36}>36 meses</option>
                                      <option value={48}>48 meses</option>
                                      <option value={60}>60 meses</option>
                                    </select>
                                  </div>

                                  {/* Porcentaje de Enganche */}
                                  <div className="col-md-6 mb-3">
                                    <label>Porcentaje de Enganche:</label>
                                    <input
                                      type="range"
                                      className="form-range"
                                      min="0"
                                      max="100"
                                      value={downPaymentPercentage}
                                      onChange={(e) =>
                                        setDownPaymentPercentage(
                                          Number(e.target.value)
                                        )
                                      }
                                    />
                                    <span>{downPaymentPercentage}%</span>
                                  </div>
                                </div>

                                <h5>
                                  Mensualidad Estimada: $
                                  {calculateMonthlyPayment()}
                                </h5>
                              </CardBody>
                            </Card>
                          </div>
                        )}
                        <div className="text-center mt-4">
                          {step > 1 && (
                            <button
                              className="btn btn-secondary mx-2"
                              onClick={handlePreviousStep}
                            >
                              Anterior
                            </button>
                          )}

                          {step < 6 && (
                            <button
                              className="btn btn-primary mx-2"
                              onClick={handleNextStep}
                            >
                              Siguiente
                            </button>
                          )}
                          {step === 6 && (
                            <button
                              className="btn btn-success mx-2"
                              onClick={handleSubmit}
                              disabled={isSubmitting || isSubmitted} // Bloquea el botón si está enviando o ya fue enviado
                            >
                              {isSubmitting
                                ? "Guardando..."
                                : isSubmitted
                                ? "Guardado"
                                : "Guardar"}{" "}
                              {/* Cambia el texto */}
                            </button>
                          )}
                        </div>
                      </CardBody>
                    </Card>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormWizards;
